import { lazy } from 'react';
import { decisionTaggingIcon } from '@tools/ui/assets';
import type { AppRouter } from '@tools/ui/types';

export const BASE_PATH = '/tagging-management';

const MainView = lazy(
  () =>
    import(
      /* webpackChunkName: "TaggingManagementRoutes" */ '../pages/MainView'
    )
);

export const taggingManagementRoutes: AppRouter = {
  modules: [
    {
      redirectFrom: [BASE_PATH, `${BASE_PATH}/*`]
    },
    {
      name: 'Tagging management',
      path: `${BASE_PATH}/main`,
      component: MainView,
      exact: false,
      icon: decisionTaggingIcon,
      pages: []
    }
  ]
};